var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-tile',{attrs:{"title":"Program","min-height":270}},[_c('h3',{staticClass:"mb-3 mx-auto"},[_vm._v(" "+_vm._s(_vm.program.name)+" ")]),_c('v-avatar',{attrs:{"size":"120"}},[_c('router-link',{attrs:{"to":{
                name: 'Program Edit',
                params: {
                    id: _vm.program.id,
                },
            }}},[_c('img',{attrs:{"src":_vm.program.icon_filepath}})])],1),_c('v-tooltip',{attrs:{"top":"","color":"secondary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-4",attrs:{"to":{
                    name: 'Program Edit',
                    params: {
                        id: _vm.program.id,
                    },
                },"color":"primary"}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-folder-edit")]),_vm._v(" Edit")],1)]}}])},[_c('span',[_vm._v("Edit Program")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }